export default __webpack_public_path__ + "static/media/accordionUp.d98fcaa3.svg";